module.exports = __webpack_public_path__ + "static/media/3.2cb7e3f7.png";